<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useHeaderAssessmentEditor } from '../../model/assessments/header-assessment-editor.hook'

defineOptions({
  name: 'HeaderAssessmentEditor',
})

const {
  config,
} = useHeaderAssessmentEditor()
</script>

<template>
  <div class="box-assessment-editor-header">
    <NavigationBreadcrumbs :config="config" />
  </div>
</template>

<style scoped lang="scss" src="./HeaderAssessmentEditor.scss" />
